module.exports = __webpack_public_path__ + "static/zadd-c0ed26963bd30193319a6213db0efcda.jpg";